import {
  createAction,
  withMatcher,
  Action,
  ActionWithPayload,
} from "utils/reducer/reducer.utils";
import { SERVICE_ACTION_TYPES } from "./service.types";
import { User } from "utils/types/user";

export type FetchDisplayServices =
  Action<SERVICE_ACTION_TYPES.FETCH_DISPLAY_SERVICES>;
export const fetchDisplayServices = withMatcher(
  (): FetchDisplayServices =>
    createAction(SERVICE_ACTION_TYPES.FETCH_DISPLAY_SERVICES)
);

export type FetchServices = ActionWithPayload<
  SERVICE_ACTION_TYPES.FETCH_SERVICES,
  User
>;
export const fetchOurServices = withMatcher(
  (user: User): FetchServices =>
    createAction(SERVICE_ACTION_TYPES.FETCH_SERVICES, user)
);

export type FetchServiceProviders = ActionWithPayload<
  SERVICE_ACTION_TYPES.FETCH_SERVICE_PROVIDERS,
  User
>;
export const fetchAllServiceProviders = withMatcher(
  (user: User): FetchServiceProviders =>
    createAction(SERVICE_ACTION_TYPES.FETCH_SERVICE_PROVIDERS, user)
);
